import { Label } from "../../screens/complaint/Complaint.styled";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { ButtonsContainer } from "../move-inRegistrationTabs/move-inTabs.styled";
import { TabContainer } from "../SocialCaseTbas/Social.styled";
import styled from "styled-components";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";
import { FC, ReactElement, useEffect, useRef, useState } from "react";
import { Modal, Typography } from "@mui/material";
import DelModal from "./DeleteModal";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Spinner, SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";

// import { ToastContainer } from 'react-toastify';

import General from "../../stores/GeneralStore";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import CONSTANTS from "../../utils/constants";
import { NotifyError } from "../../../src/utils/ShowError";
import isValidIban from "../../utils/validateIban";
import User from "../../stores/UserStore";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import zIndex from "@mui/material/styles/zIndex";
import { get } from "http";

interface Obj {
  [key: string]: any;
}

type BankDetails = {
  customerName: string;
  bankAccountNumber: string;
  ibanNumber: string;
  swiftCode: string;
  bankBranchName: string;
  bankType: string;
  bankName: string;
  country: string;
};

interface Props extends BaseProps {
  bankData: Obj;
  loadBankDetails: () => Promise<void>;
  saveDetails: (bankDetails: BankDetails) => void;
  deleteDetails: (bankDetails: any) => void;
  bankLoader: boolean;
  // bankDetails: {
  //   bankName: string;
  //   bankNameValue: string;
  //   id: number;
  //   swiftCode: string;
  //   otherBankName: string;
  // };
}
interface BankOption {
  bankName: string;
  id: number;
  swiftCode: string;
  otherBankName: string;
}

export const AmountCard = styled.div`
  color: #101e8e;
  background: #edf4f6;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-evenly;
  padding: 1rem;
  width: 60%;
`;

// const ibanRegex:any=/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$/


const BankDetails: FC<Props> = ({
  saveDetails,
  deleteDetails,
  loadBankDetails,
  bankData,
  bankLoader,
}: Props): ReactElement => {
const [delModalOpen, setDELModalOpen] = useState(false);
const [bankTypeValue, setBankType] = useState(bankData?.bankType?.value);
const [bankNames, setBankNames] = useState<BankOption[]>([])

// console.log("bankObject", bankDetails);

const setOtherBankName = (value: string) => { 
  localStorage.setItem("otherBankName", value);
};


const [otherBankSelected, setOtherbankSelected] = useState(false);
const [swiftCode, setSwiftCode] = useState(bankData.swiftCode);
const [bankValue, setBankValue] = useState<any>(bankData);
const [otherBank, setOtherBank] = useState("");

const bankTyeRef:any=useRef<HTMLInputElement | null>(null);
const countryRef:any=useRef<HTMLSelectElement | null>(null);
  const phoneNumberRegex: any =
  /^((\+971|00971){1}(2|3|4|6|7|9|50|51|52|55|56){1}([0-9]{7}))$/;
// const ibanRegexUAE: any =bankTypeValue=="DOMESTIC"? /AE[0-9]{2}[0-9]{3}[0-9]{16}$/:/[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}/;
const ibanRegexUAE: any = /AE[0-9]{2}[0-9]{3}[0-9]{16}$/;
const ibanRegexIn: any =
  /[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}/;
// const bankAccountNumberRegex:any=/^0{3}1\d{10}$/
// const bankAccountNumberRegex: any = /[0-9]{16}/;
const bankAccountNumberRegex: any = /^\d{16}$/;
const swiftCodeRegex: any =
  /^[A-Za-z0-9]{4}[A-Za-z]{2}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/;
const lengthMorethanfour = /^.{4,}$/;

const validationSchema = Yup.object().shape({
  customerName: Yup.string() .matches(/^[a-zA-Z\u0600-\u06FF\u0900-\u097F ,&/]+$/, General?.codeLabels["cm_valid_accoName"]?.label ?General?.codeLabels["cm_valid_accoName"]?.label:"Please Enter Valid Account Name").required(General?.codeLabels["cm_nocentercustomername"]?.label?General?.codeLabels["cm_nocentercustomername"]?.label:"Please enter Customer Name"),
  // bankType: Yup.string().required(General?.codeLabels["cm_ank_type_req"]?.label ?General?.codeLabels["cm_ank_type_req"]?.label:"Bank Type is required"),
  bankAccountNumber: Yup.string()
    .matches(/^\d{16}$/, General?.codeLabels["cm_bank_16"]?.label ?General?.codeLabels["cm_bank_16"]?.label:"Bank Account Number must be 16 digits")
    .required(General?.codeLabels["cm_enter_bankacctno"]?.label ?General?.codeLabels["cm_enter_bankacctno"]?.label:"Please Enter Bank Account Number"),
  ibanNumber: Yup.string()
    .matches(bankTypeValue=="DOMESTIC"? ibanRegexUAE:ibanRegexIn, General?.codeLabels["cm_iban_invalid"]?.label ?General?.codeLabels["cm_iban_invalid"]?.label:"Invalid IBAN format")
    .required(General?.codeLabels["cm_enter_iban"]?.label ?General?.codeLabels["cm_enter_iban"]?.label:"Required"),
  swiftCode: Yup.string()
    .matches(swiftCodeRegex, General?.codeLabels["cm_invalid_swift"]?.label ?General?.codeLabels["cm_invalid_swift"]?.label:"Invalid Swift Code format")
    .required(General?.codeLabels["cm_enter_swiftcode"]?.label ?General?.codeLabels["cm_enter_swiftcode"]?.label:"Required"),
  bankBranchName: Yup.string().matches(/^[a-zA-Z\u0600-\u06FF\u0900-\u097F ,&/]+$/, General?.codeLabels["cm_branchnamelimit"]?.label ?General?.codeLabels["cm_branchnamelimit"]?.label:"Please Enter Valid Branch Name")
    .min(4, General?.codeLabels["cm_branchname_limit"]?.label ?General?.codeLabels["cm_branchname_limit"]?.label:"Bank Branch Name must be at least 4 characters")
    .required(General?.codeLabels["cm_enter_bankbranchname"]?.label ),
  bankName: Yup.string()
    // .matches(/^[a-zA-Z\u0600-\u06FF\u0900-\u097F ,&/]+$/, General?.codeLabels["cm_valid_bnkName"]?.label ? General?.codeLabels["cm_valid_bnkName"]?.label : "Please Enter Valid Bank Name")
    .required(General?.codeLabels["cm_enter_bank_name"]?.label ? General?.codeLabels["cm_enter_bank_name"]?.label : "Bank Branch Name Required"),
  // Add validations for other fields
  // country: Yup.string().required(General?.codeLabels["cm_country_req"]?.label ?General?.codeLabels["cm_country_req"]?.label:"Country is required"), // Add validation for "country" field
  otherBankName: Yup.string().when("bankName", {
    is: (val: string) => val === "Other",
    then: () => Yup.string().required('Please enter other bank name'),
    otherwise: () => Yup.string()
  })
});


  const handleMakeRefund = (values: any) => {
    // console.log("submit errors",Object.values(formik.errors);)
    if(isValidIban(values?.ibanNumber)){
      const {
        customerName,
        bankType,
        bankAccountNumber,
        ibanNumber,
        swiftCode,
        bankBranchName,
        bankName,
        country,
        otherBankName
      } = values;
      console.log("otherBankSelected", otherBankSelected);
      console.log("submit values",values)
      console.log("otherBankhere", otherBank)
      console.log("bankNamehere,", bankName)
      const bankDetailsRequest: any = {
        customerName,
        bankType:bankTyeRef?.current?.value,
        bankAccountNumber,
        ibanNumber,
        swiftCode,
        bankBranchName,
        action:bankData?.bankAccountReferenceId?"UPDATE": "ADD",
        bankName:otherBankSelected ? otherBank : bankName, 
        country:countryRef?.current?.value,
        bankAccountReferenceId:bankData?.bankAccountReferenceId?bankData?.bankAccountReferenceId:null
      };
  
      saveDetails(bankDetailsRequest)
    }else{
      NotifyError(General?.codeLabels['cm_iban_invalid']?.label)
    }
   
  };

  const deleteBankDetails = async() => {
   await loadBankDetails();
    const bankDetailData = {
      customerName: null,
      bankType: null,
      bankAccountNumber: null,
      ibanNumber: null,
      swiftCode: null,
      bankBranchName: null,
      action: "DELETE",
      bankName: null,
      country: null,
      bankAccountReferenceId: bankData?.bankAccountReferenceId,
    };
    deleteDetails(bankDetailData);
    localStorage.removeItem("selectedBankName");
    localStorage.removeItem("otherBankName");
    setDELModalOpen(false);
  };

  useEffect(() => {
    loadBankDetails();
  }, []);

  const setSelectedValue = (value : any) => {
    localStorage.setItem("selectedBankName", JSON.stringify(value));
  }
 
  useEffect(() => {
    const fetchBankOptions = async () => {
      const options = await User.getSwiftCode({
        errorId: "getBankDataError",
        data: User.profile.language.key,
      });
      setBankNames(options.result);
      // setBankOptions(prev => [...prev, options.bankName]);
    };
    fetchBankOptions();
  }, []);

  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;

  return (
    <div
      style={{
        backgroundColor: contrast?.contrastBackground
          ? contrast?.contrastBackground
          : "#fff",
        width: General?.isLargeScreen ? "93%" : "100%",
        padding: General?.isLargeScreen ? "3.125rem 9rem" : "0rem 1rem",
        marginLeft: General?.isLargeScreen ? "50px" : "",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: General?.isLargeScreen ? "row" : "column",
          alignItems: General?.isLargeScreen ? "center" : "",
          justifyContent: "space-between",
        }}
      >
        <h3
          style={{
            fontFamily: "Segoe UI",
            fontStyle: "normal",
            fontWeight: "700",
            fontSize: `${1.5 * General.accessibility.fontSize}rem`,
            lineHeight: "32px",
            color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
          }}
        >
          {General?.codeLabels["cm_bankdetailsheader"]?.label !== undefined
            ? General?.codeLabels["cm_bankdetailsheader"]?.label
            : "Bank Account Details"}
        </h3>
        <ButtonSecondary
          style={{
            width: General?.isLargeScreen ? "10%" : "100%",
            padding: "5px 86px",
            whiteSpace: "nowrap",
            fontWeight: "bold",
            fontSize: `${General.accessibility.fontSize}rem`,
            zIndex: 0,
            color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
            background: contrast?.contrastBackground ? contrast?.contrastBackground : "",
            borderColor: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
          }}
          onClick={() => setDELModalOpen(true)}
        >
          {General?.codeLabels["cm_del_bank_header"]?.label !== undefined
            ? General?.codeLabels["cm_del_bank_header"]?.label
            : "Delete Bank Details"}
        </ButtonSecondary>
      </div>
      <Formik
        initialValues={{
          customerName: bankData?.customerName || "",
          bankType: bankData?.bankType?.value || "",
          bankAccountNumber: bankData?.bankAccountNumber || "",
          ibanNumber: bankData?.ibanNumber || "",
          swiftCode: bankData.swiftCode,
          bankBranchName: bankData?.bankBranchName || "",
          bankName: bankData.bankName,
          otherBankName: "",
        }}
        validationSchema={validationSchema}
        onSubmit={handleMakeRefund}
        enableReinitialize={true}
      >
        {(formik) => (
          <Form id="bankDetailsForm">
            <TabContainer
              style={{
                flexDirection: "column",
                width: General?.isLargeScreen ? "" : "100%",
                display: "flex",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: General?.isLargeScreen ? "row" : "column",
                  gap: "1.5rem",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1.5rem",
                  }}
                >
                  {/* Account Name */}
                  <Label
                    style={{
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : ColorAss,
                      fontFamily: "Segoe UI",
                      fontStyle: "normal",
                      fontWeight: "700",
                      fontSize: `${General.accessibility.fontSize}rem`,
                      lineHeight: "16px",
                      gap: "0.5rem",
                      height: "100px",
                      width: General?.isLargeScreen ? "537px" : "100%",
                    }}
                  >
                    {General?.codeLabels["cm_customername"]?.label !==
                    undefined
                      ? General?.codeLabels["cm_customername"]?.label
                      : "Customer Name"}*
                    <Field
                      type="text"
                      name="customerName"
                      placeholder={
                        General?.codeLabels["cm_enter_customername"]?.label
                      }
                      style={{ background: contrast?.contrastColor ? contrast?.contrastColor:"#edf4f6", color: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss }}
                    />
                    <div style={{ height: "0.5rem" }}>
                      {" "}
                      <ErrorMessage
                        name="customerName"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </Label>

                  {/* Country */}

                  <Label
                    style={{
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : ColorAss,
                      fontFamily: "Segoe UI",
                      fontStyle: "normal",
                      fontWeight: "700",
                      fontSize: `${General.accessibility.fontSize}rem`,
                      lineHeight: "16px",
                      gap: "0.5rem",
                      height: "100px",
                      width: General?.isLargeScreen ? "537px" : "100%",
                    }}
                  >
                    {General?.codeLabels["cm_country"]?.label !== undefined
                      ? General?.codeLabels["cm_country"]?.label
                      : "Country"}
                    <select
                      // as="select"
                      name="country"
                      ref={countryRef}
                      style={{
                        height: "55px",
                        background: contrast?.contrastColor ? contrast?.contrastColor:"#E5EFF2",
                        color: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss
                      }}
                    >
                  {bankTyeRef?.current?.value=='INTERNATIONAL'?
                    <>
                        <option value={""}>
                        {General?.codeLabels["cm_mob_select"]?.label !==
                        undefined
                          ? General?.codeLabels["cm_mob_select"]?.label
                          : "Select"}
                      </option>
                      {General?.codeLabels["cm_pdc_paymentaccounts"]
                        ?.languageCode == "ARA"
                        ? CONSTANTS.countriesAr.map((nationality) => {
                            return (
                              <option
                                value={nationality?.key}
                                selected={
                                  bankData?.country?.key == nationality?.key
                                    ? true
                                    : false
                                }
                              >
                                {nationality?.value}
                              </option>
                            );
                          })
                        : General?.codeLabels["cm_pdc_paymentaccounts"]
                            ?.languageCode == "HIN"
                        ? CONSTANTS.countriesHi.map((nationality) => {
                            return (
                              <option
                                value={nationality?.key}
                                selected={
                                  bankData?.country?.key == nationality?.key
                                    ? true
                                    : false
                                }
                              >
                                {nationality?.value}
                              </option>
                            );
                          })
                        : CONSTANTS.countriesEn.map((nationality) => {
                            return (
                              <option
                                value={nationality?.key}
                                selected={
                                  bankData?.country?.key == nationality?.key
                                    ? true
                                    : false
                                }
                              >
                                {nationality?.value}
                              </option>
                            );
                          })}
                    </>
                    :
                  <>
                  {General?.codeLabels["cm_pdc_paymentaccounts"]
                        ?.languageCode == "ARA"
                         ?
                              <option
                                value={"ARE"}
                              >
                                  {"الإمارات العربية المتحدة"}
                              </option>

                        : General?.codeLabels["cm_pdc_paymentaccounts"]
                            ?.languageCode == "HIN"
                        ?
                              <option
                                value={"ARE"}
                              >
                                {"संयुक्त अरब अमीरात"}
                              </option>
                        : 
                              <option
                                value={"ARE"}
                              
                              >
                                {"United Arab Emirates"}
                              </option>
                            
                          }
                  </>
                  }
                    </select>
                    <div style={{ height: "0.5rem" }}>
                    </div>
                  </Label>

                  {/* IBAN Number */}
                  <Label
                    style={{
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : ColorAss,
                      fontFamily: "Segoe UI",
                      fontStyle: "normal",
                      fontWeight: "700",
                      fontSize: `${General.accessibility.fontSize}rem`,
                      lineHeight: "16px",
                      gap: "0.5rem",
                      height: "100px",
                      width: General?.isLargeScreen ? "537px" : "100%",
                      marginBottom: otherBankSelected && /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ? "3.7rem" : "0rem"
                    }}
                  >
                    {General?.codeLabels["cm_iban_umber"]?.label
                      ? General?.codeLabels["cm_iban_umber"]?.label
                      : "IBAN Number"}*
                    <Field
                      type="text"
                      name={"ibanNumber"}
                      placeholder={General?.codeLabels["cm_enteriban"]?.label}
                      style={{ background: contrast?.contrastColor ? contrast?.contrastColor:"#edf4f6", color: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss }}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      const iban = e.target.value;
                      formik.setFieldValue("ibanNumber", iban);
                      const digits = iban.replace(/\D/g, "");
                      const last16 = digits.slice(-16);
                      if (last16.length === 16) {
                        formik.setFieldValue("bankAccountNumber", last16);
                      }
                      else{
                        formik.setFieldValue("bankAccountNumber", "");
                      }
                      }}
                    />
                    <div style={{ height: "0.5rem" }}>
                      {" "}
                      <ErrorMessage
                        name="ibanNumber"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </Label>

                    <Label
                    style={{
                      color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : ColorAss,
                      fontFamily: "Segoe UI",
                      fontStyle: "normal", 
                      fontWeight: "700",
                      fontSize: `${General.accessibility.fontSize}rem`,
                      lineHeight: "16px",
                      gap: "0.5rem",
                      height: "100px",
                      width: General?.isLargeScreen ? "537px" : "100%",
                    }}
                    >
                    {General?.codeLabels["cm_bankname"]?.label !== undefined
                      ? General?.codeLabels["cm_bankname"]?.label
                      : "Bank Name"}*

                    <Field name="bankName">
                      {({ field, form }: any) => {
                        return (
                          <>
                            <Autocomplete
                              options={bankNames}
                              style={{width:'100%',height: '55px',
                                background: contrast?.contrastColor
                                ? contrast?.contrastColor
                                : "#edf4f6",
                                color: contrast?.contrastBackground
                                ? contrast?.contrastBackground 
                                  : ColorAss,
                                
                              }}
                              sx={{
                                display: 'inline-block', 
                                width: '100%',
                                marginTop: '10px',
                                marginBottom: '10px',
                                height: '55px',
                                '& .MuiOutlinedInput-root': {
                                  height: '55px',
                                  padding: '0 8px',
                                 
                                },
                                '&.MuiInputBase-root': {
                                  height: '55px',
                                },
                                '& input': {
                                    height: '20px',
                                    padding: '2px 8px',
                                    border: 'none !important',
                                    fontFamily: "Segoe UI",
                                    background: `${contrast?.contrastColor
                                    ? contrast?.contrastColor
                                    : "#edf4f6"} !important`,
                                    color:'#000',
                                    fontSize: `${General.accessibility.fontSize}rem`,
                                    
                                },
                                '&.MuiButtonBase-root': {
                                backgroundColor: contrast?.contrastColor
                                ? contrast?.contrastColor
                                : "#edf4f6",
                                color: contrast?.contrastBackground
                                ? contrast?.contrastBackground
                                : ColorAss,
                      
                        }
                              }}
                              getOptionLabel={(option) => option?.bankName === "null" ? "" : option?.bankName || ""}
                              value={bankValue}
                              // defaultValue={bankNames[0]}
                              onChange={async (_, newValue) => {
                                if (newValue?.bankName === 'Other') { 
                                  setOtherbankSelected(true);
                                  formik.setFieldValue("otherBankName", "");
                                  setOtherBank("");
                                } else {
                                  setOtherbankSelected(false);
                                  formik.setFieldValue("swiftCode", newValue?.swiftCode);
                                }

                                await Promise.all([
                                  formik.setFieldValue("swiftCode", newValue?.swiftCode || ""),
                                  formik.setFieldValue("bankName", newValue?.bankName || "")
                                ]);

                                setBankValue(newValue);
                                setSwiftCode(newValue?.swiftCode ?? "");
                                
                                await formik.validateForm();
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  onBlur={() => form.setFieldTouched("bankName", true)}
                                  placeholder={General?.codeLabels["cm_enter_bank_name"].label}
                                  style={{
                                    background: contrast?.contrastColor ? contrast?.contrastColor : "#edf4f6",
                                    color: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss
                                  }}
                                />
                              )}
                            />
                          

                            {otherBankSelected && (
                              <>
                              <Label
                                style={{
                                  color: contrast?.contrastColor
                                  ? contrast?.contrastColor
                                  : ColorAss,
                                  fontFamily: "Segoe UI",
                                  fontStyle: "normal", 
                                  fontWeight: "700",
                                  fontSize: `${General.accessibility.fontSize}rem`,
                                  lineHeight: "16px",
                                  gap: "0.5rem",
                                  height: "100px",
                                    width: General?.isLargeScreen ? "537px" : "100%",
                                }}
                                >
                                {General?.codeLabels["cm_bankname"]?.label !== undefined
                                  ? General?.codeLabels["cm_bankname"]?.label
                                  : "Bank Name"}*
                                <Field
                                  name="otherBankName"
                                  type="text"
                                  placeholder="Enter other bank name"
                                  value={otherBank}
                                  fullWidth
                                  style={{
                                    background: contrast?.contrastColor ? contrast?.contrastColor : "#edf4f6",
                                    color: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss,
                                    zIndex: 789,
                                  }}
                                  onChange={(e: any) => {
                                    form.setFieldValue("otherBankName", e.target.value);
                                    setOtherBank(e.target.value);
                                  }}
                                />
                                <div style={{ height: "0.5rem" }}>
                                  <ErrorMessage
                                    name="otherBankName"
                                    component="div"
                                    className="error-message"
                                  />
                                  </div>
                                </Label>
                              </>
                            )}
                          </>
                        );
                      }}
                    </Field>
                    <div style={{ height: "0.5rem" }}>
                      <ErrorMessage
                        name="bankName"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </Label>
              
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1.5rem",
                  }}
                >
                  {/* Bank Type */}

                  <Label
                    
                    style={{
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : ColorAss,
                      fontFamily: "Segoe UI",
                      fontStyle: "normal",
                      fontWeight: "700",
                      fontSize: `${General.accessibility.fontSize}rem`,
                      lineHeight: "16px",
                      gap: "0.5rem",
                      height: "100px",
                      width: General?.isLargeScreen ? "537px" : "100%",
                    }}
                  >
                    {General?.codeLabels["cm_banktype"]?.label !== undefined
                      ? General?.codeLabels["cm_banktype"]?.label
                      : "Bank Type"}*
                    <Field
                      as="select"
                      name="bankType"
                      value={bankTypeValue}
                      onChange={(e: any) => setBankType(e.target.value)}
                      innerRef={bankTyeRef}
                      style={{
                        height: "55px",

                        fontSize: `${General.accessibility.fontSize}rem`,
                        background: contrast?.contrastColor ? contrast?.contrastColor:"#edf4f6",
                        color: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss
                      }}
                    >
                      <option disabled>
                        {General?.codeLabels["cm_select"]?.label !== undefined
                          ? General?.codeLabels["cm_select"]?.label
                          : "Select"}
                      </option>
                      <option
                        selected={
                          bankData?.bankType?.value == "DOMESTIC" ? true : false
                        }
                        value={"DOMESTIC"}
                      >
                        {General?.codeLabels["cm_domestic"]?.label !== undefined
                          ? General?.codeLabels["cm_domestic"]?.label
                          : "Domestic"}
                      </option>
                      {/* <option
                        selected={
                          bankData?.bankType?.value == "INTERNATIONAL"
                            ? true
                            : false
                        }
                        value={"INTERNATIONAL"}
                      >
                        {General?.codeLabels["cm_international"]?.label !==
                        undefined
                          ? General?.codeLabels["cm_international"]?.label
                          : "International"}
                      </option> */}
                    </Field>
                    <div style={{ height: "0.5rem" }}>
                      {" "}
                      <ErrorMessage
                        name="bankType"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </Label>

                  {/* Swift Code */}
                 
                  <Label
                    style={{
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : ColorAss,
                      fontFamily: "Segoe UI",
                      fontStyle: "normal",
                      fontWeight: "700",
                      fontSize: `${General.accessibility.fontSize}rem`,
                      lineHeight: "16px",
                      gap: "0.5rem",
                      height: "100px",
                      width: General?.isLargeScreen ? "" : "100%",
                    }}
                  >
                    {General?.codeLabels["cm_accountno"]?.label !== undefined
                      ? General?.codeLabels["cm_accountno"]?.label
                      : "Bank Account Number"}*
                    <Field
                      
                      type="text"
                      name="bankAccountNumber"
                      placeholder={
                        General?.codeLabels["cm_enter_bankacctno"]?.label
                      }
                      style={{
                        background: contrast?.contrastColor ? contrast?.contrastColor : "#edf4f6",
                        color: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss
                      }}
                      disabled
                      readOnly
                    />
                    <div style={{ height: "0.5rem" }}>
                      {" "}
                      <ErrorMessage
                        name="bankAccountNumber"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </Label>
                  {/* Bank Branch Name */}

                  <Label
                    style={{
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : ColorAss,
                      fontFamily: "Segoe UI",
                      fontStyle: "normal",
                      fontWeight: "700",
                      fontSize: `${General.accessibility.fontSize}rem`,
                      lineHeight: "16px",
                      gap: "0.5rem",
                      height: "100px",
                      width: General?.isLargeScreen ? "" : "100%",
                    }}
                  >
                    {General?.codeLabels["cm_swiftcode"]?.label !== undefined
                      ? General?.codeLabels["cm_swiftcode"]?.label
                      : "Swift Code"}*
                    <Field
                      type="text"
                      value={swiftCode}
                      name="swiftCode"
                      placeholder={
                        General?.codeLabels["cm_enter_swiftcode"]?.label
                          ? General?.codeLabels["cm_enter_swiftcode"]?.label
                          : "Please enter Swift Code"
                      }
                      onChange={(e: any) => { 
                        setSwiftCode(e.target.value);
                        formik.setFieldValue("swiftCode", e.target.value);
                        console.log("swiftCode", formik.values.swiftCode);
                      }}
                      style={{ background: contrast?.contrastColor ? contrast?.contrastColor:"#edf4f6", color: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss }}

                    />
                    <div style={{ height: "0.5rem" }}>
                      <ErrorMessage
                        name="swiftCode"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </Label>


                  {/* Bank Name */}
                  <Label
                    
                    style={{
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : ColorAss,
                      fontFamily: "Segoe UI",
                      fontStyle: "normal",
                      fontWeight: "700",
                      fontSize: `${General.accessibility.fontSize}rem`,
                      lineHeight: "16px",
                      gap: "0.5rem",
                      height: "100px",
                      width: General?.isLargeScreen ? "" : "100%",
                    }}
                  >
                    {General?.codeLabels["cm_bankbranchname"]?.label !==
                    undefined
                      ? General?.codeLabels["cm_bankbranchname"]?.label
                      : "Branch Name"}*
                    <Field
                      
                      type="text"
                      name="bankBranchName"
                      placeholder={
                        General?.codeLabels["cm_enter_bankbranchname"]?.label
                      }
                      style={{ background: contrast?.contrastColor ? contrast?.contrastColor:"#edf4f6", color: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss }}

                    />
                    <div style={{ height: "0.5rem" }}>
                      {" "}
                      <ErrorMessage
                        name="bankBranchName"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </Label>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: General?.isLargeScreen ? "row" : "column",
                  width: General?.isLargeScreen ? "40vw" : "100%",
                  height: "20vh",
                  alignItems: "center",
                  gap: "2rem",
                  marginTop: "2.5rem",
                }}
              >
                <ButtonSecondary
                  style={{
                    width: General?.isLargeScreen ? "144px" : "100%",
                    height: "50px",
                    padding: "auto",
                    fontWeight: "bold",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: contrast?.contrastBackground
                      ? contrast?.contrastColor
                      : ColorAss,
                    background: contrast?.contrastColor
                      ? contrast?.contrastBackground
                      : "#fff",
                      borderColor: contrast?.contrastColor ? contrast?.contrastColor : ColorAss
                  }}
                  type="button" // Make sure it's a button type
                >
                  {General?.codeLabels["cm_usepassloginpagecancel"]?.label !==
                  undefined
                    ? General?.codeLabels["cm_usepassloginpagecancel"]?.label
                    : "CANCEL"}
                </ButtonSecondary>
                <ButtonSecondary
                  style={{
                    width: General?.isLargeScreen ? "144px" : "100%",
                    height: "50px",
                    padding: "auto",

                    fontWeight: "bold",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : "#fff",
                    background: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : ColorAss,
                      border:"none"
                  }}
                  type="submit" // Make sure it's a submit type
                >
                  {bankLoader ? (
                    <Spinner width="30px" height="30px" />
                  ) : General?.codeLabels["cm_save"]?.label ? (
                    General?.codeLabels["cm_save"]?.label
                  ) : (
                    "Save"
                  )}
                </ButtonSecondary>
              </div>
            </TabContainer>
          </Form>
        )}
      </Formik>

      <Modal
        open={delModalOpen}
        onClose={() => setDELModalOpen(false)}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <DelModal
          onClose={() => setDELModalOpen(false)}
          delData={deleteBankDetails}
        />
      </Modal>
    </div>
  );
};

export default observer(BankDetails);